export interface GradingConfig {
  // Date after which the new grading report should be used
  modernGradingCutoffDate: Date;
}

export const gradingConfig: GradingConfig = {
  modernGradingCutoffDate: new Date('2025-05-05T00:00:00+00:00'),
};
